import { useEffect, useState } from "react";
import { useQueryRoute } from "../../../hooks/useQueryRoute";
import { searchShowHouses } from "./utils";
import MessageHouseNotPresent from "./../../atoms/MessageHouseNotPresent";
import ErrorMessageResponse from "../../atoms/MessageErrorResponse";
import Formbox from "../../organisms/FormBox";
import { Spinner } from "react-bootstrap";
import { useIntl } from "react-intl";
import styles from "./index.module.scss";

const ShowHousesGiantsysTracking = () => {
  const [housePresent, setHousePresent] = useState("loading");
  const [messageError, setMessageError] = useState(null);
  const [fields, setFields] = useState();
  const [house, setHouse] = useState();
  const intl = useIntl();
  const dataSearchHouse = {
    trackingSysId: parseInt(useQueryRoute("trackingSysId")),
    houseNum: useQueryRoute("houseNum"),
    houseYear: parseInt(useQueryRoute("houseYear")),
  };

  useEffect(() => {
    searchShowHouses(
      dataSearchHouse,
      setHouse,
      setFields,
      setMessageError,
      setHousePresent,
    );
  }, []);
  return (
    <div className={styles.ShowHouse}>
      {(() => {
        switch (housePresent) {
          case false:
            return <MessageHouseNotPresent message={messageError} />;
          case true:
            return (
              <div className={styles.ShowHouseBox}>
                <Formbox house={house} fields={fields} />
              </div>
            );
          case null:
            return (
              <ErrorMessageResponse
                message={messageError || intl.messages.messageErrorParams}
              />
            );
          default:
            return <Spinner animation="border" variant="danger" />;
        }
      })()}
    </div>
  );
};

export default ShowHousesGiantsysTracking;
